import React, { useRef } from 'react';
import Reaptcha from 'reaptcha';
import PropTypes from 'prop-types';
import { initDataLayer } from '../../../utilities/functions';

const Recaptcha = ({ token, classes, src }) => {
	const [captchaToken, setCaptchaToken] = token;
	const captchaRef = useRef(null);

	const verify = () => {
		captchaRef.current.getResponse().then((res) => {
			setCaptchaToken(res);
		});
	};

	return (
		<Reaptcha
			id='recaptcha'
			className={classes}
			sitekey={process.env.GATSBY_RECAPTCHA_KEY}
			ref={captchaRef}
			onVerify={verify}
			onRender={() => initDataLayer('Recaptcha_Load', { src })}
		/>
	);
};

export default Recaptcha;

Recaptcha.propTypes = {
	token: PropTypes.array,
	classes: PropTypes.string,
	src: PropTypes.string,
};
